import z from 'zod';
import { scopedEntity, assetRef, anyLoraConfig, kioskConfig, string, } from '../common';
export var DeviceType;
(function (DeviceType) {
    DeviceType["AppDevice"] = "appDevice";
    DeviceType["Lora"] = "lora";
    DeviceType["LoraGateway"] = "loraGateway";
    DeviceType["Flic"] = "flic";
    DeviceType["Generic"] = "generic";
    DeviceType["Kiosk"] = "kiosk";
})(DeviceType || (DeviceType = {}));
export const device = z.object({
    ...scopedEntity.shape,
    asset: assetRef.nullable(),
    name: string.optional(),
    deviceId: string,
    type: z.nativeEnum(DeviceType),
    loraConfig: anyLoraConfig.nullish(),
    kioskConfig: kioskConfig.nullish(),
    battery: z.number().optional(),
    rssi: z.number().optional(),
    snr: z.number().optional(),
});
